import "./noticeTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const NoticeTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Notice
  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const res = await axios.get(
          BASE_URL + `/api/notice/findAllNotice/${userId}`
        );
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchNotice();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        BASE_URL + `/api/notice/deleteNotice/${id}`
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleUpdate = (noticeData) => {
    navigate("/notice/newNotice", { state: { notice: noticeData } }); // Pass user data to finance
  };

  const noticeListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "noticeTitle",
      headerName: "Notice Title",
      width: 300,
    },
    {
      field: "noticeDescription",
      headerName: "Notice Description",
      width: 400,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 110,
    },
    {
      field: "editedDate",
      headerName: "Edited Date",
      width: 110,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <IconButton color="primary" aria-label="addButton">
              <Link to="/notice/newNotice">
                <Add />
              </Link>
            </IconButton>

            <IconButton
              onClick={() => handleUpdate(params.row)}
              color="primary"
              aria-label="update"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedNotice(params.row);
                setOpenDialog(true);
              }}
              color="error"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedNotice(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedNotice) {
      await handleDelete(selectedNotice._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Notice
        </Typography>
        <Link to="/notice/newNotice">
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 25 }}
          >
            Add Notice
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        <DataGrid
          className="datagrid"
          rows={data}
          columns={noticeListColumns.concat(actionColumn)}
          pageSize={5}
          rowsPerPageOptions={[5]}
          checkboxSelection
          getRowId={(row) => row._id}
        />
        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this Notice?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
};

export default NoticeTable;
